"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileAppMenu = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _MobileHeaderModal = require("./MobileHeaderModal");
var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MobileAppMenu = function MobileAppMenu(props) {
  var appMenuItems = props.appMenuItems,
    appNavigator = props.appNavigator,
    showHomeIcon = props.showHomeIcon,
    homeRoute = props.homeRoute,
    onToggleAppMenu = props.onToggleAppMenu;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var handleToggleNavigation = function handleToggleNavigation() {
    var newState = !isShown;
    setIsShown(newState);
    onToggleAppMenu(newState);
  };
  var hasAppContent = !((0, _isNil["default"])(appMenuItems) && (0, _isNil["default"])(appNavigator));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar-header min-width-50 padding-5 overflow-hidden position-relative display-flex align-items-center",
    onClick: handleToggleNavigation
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "navbar-brand height-40 width-40 ".concat(showHomeIcon ? 'home-icon' : '')
  }, !hasAppContent && homeRoute), hasAppContent && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute right-2 bottom-0 text-color-white rotate-45"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-triangle-right"
  }))), appNavigator && /*#__PURE__*/_react["default"].createElement(_MobileHeaderModal.MobileHeaderModal, {
    show: isShown,
    modalClassName: "padding-top-25",
    onClose: handleToggleNavigation
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "width-100pct height-100pct"
  }, appNavigator)), appMenuItems && /*#__PURE__*/_react["default"].createElement(_MobileHeaderModal.MobileHeaderModal, {
    show: isShown,
    modalClassName: "padding-15",
    onClose: handleToggleNavigation
  }, appMenuItems.map(function (module) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: "link-icon-".concat(module.key)
    }, module.route);
  })));
};
exports.MobileAppMenu = MobileAppMenu;
MobileAppMenu.propTypes = {
  homeRoute: _propTypes["default"].node,
  showHomeIcon: _propTypes["default"].bool,
  appMenuItems: _propTypes["default"].arrayOf(_modulePropTypes["default"]),
  appNavigator: _propTypes["default"].element,
  onToggleAppMenu: _propTypes["default"].func
};